import { useEffect, useState } from "react";
import { getAllCategories } from "../services/api";

export default function useCategories() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getAllCategories().then((data) => {
      setCategories(data);
    });
  }, []);

  return categories;
}
